import { Props } from "./MediaPlayer.model";
import { useMediaPlayer } from "./useMediaPlayer";
import styles from "./MediaPlayer.module.scss";


const MediaPlayer = ({ onReady, type, url }: Props) => {
	const { isAudio, state: { videoRef } } = useMediaPlayer({ onReady, type, url });

	return <div className={styles.player}>
		<div data-vjs-player>
			<video ref={videoRef} className={`video-js vjs-big-play-centered ${isAudio() && 'audio'}`} />
		</div>
	</div>
}

export default MediaPlayer;